import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ResigteringService {
  private isBrowser: boolean;

  constructor(
    private _HttpClient: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  user_Resigter(data: any): Observable<any> {
    return this._HttpClient.post(
      `${environment.Server_URL}/register`,
      data
    );
  }

  editUser(id: any, data: any): Observable<any> {
    return this._HttpClient.post(
      `${environment.Server_URL}/update/user/${id}`,
      data
    );
  }

  verificationCode(verification_code: string): Observable<any> {
    const email = this.isBrowser
      ? sessionStorage.getItem('email')
      : null;

    const obj = {
      verification_code: verification_code.toString(),
      email,
    };

    return this._HttpClient.post(
      `${environment.Server_URL}/verify-code`,
      obj
    );
  }

  SkipVerificationCode(): Observable<any> {
    const email = this.isBrowser
      ? sessionStorage.getItem('email')
      : null;

    return this._HttpClient.post(
      `${environment.Server_URL}/skip`,
      { email }
    );
  }

  resendOTP(): Observable<any> {
    const email = this.isBrowser
      ? sessionStorage.getItem('email')
      : null;

    return this._HttpClient.post(
      `${environment.Server_URL}/api/Authentication/ResendOTP?email=${email}`,
      {}
    );
  }

  setToken(token: string): void {
    if (this.isBrowser) {
      localStorage.setItem('token', token);
    }
  }

  getToken(): string | null {
    if (this.isBrowser) {
      return localStorage.getItem('token');
    }
    return null;
  }
}
